<delete-modal
  [id]="modalId"
  [message]="message()"
  [confirmBtnBgColorClass]="'tw-bg-blue-600 hover:tw-bg-blue-700 focus:tw-ring-blue-300'"
  (onDelete)="onConfirm()"
  (onCancel)="onCancel()"
/>
